import { Link, useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "./Root";
import { useState, useEffect, useContext } from "react";

//Describes the layout of the navigation bar to render.
//Setting top or bottom to null will hide that section.
const layout = {
	//Top describes the top of the navigation bar and the drop down menus it contains.
	top: [{
			name: "About",
			items: [
				{ name: "General About", 				path: "/about", 		hard: false },
				{ name: "Frequently Asked Questions", 	path: "/about/FAQ",  	hard: false },
				{ name: "Career Opportunities", 		path: "/about/careers", 	hard: false },
				{ name: "Contact Us", 					path: "/about/contact", 	hard: false }
			]
		}, {
			name: "Services",
			items: [
				{ name: "Portal",						path: "/portal",									hard: true,	conditional: "PORTAL"			},
				{ name: "Home Assistant",				path: "https://homeassistant.huskydevelopment.com", hard: true, conditional: "HOMEASSISTANT"	}
			]
		}, {
			name: "Games",
			items: [
				{ name: "All Games", 					path: "/games",			 	hard: false },
				{ name: "Tic Tac Toe", 					path: "/games/tic-tac-toe",	hard: false },
				{ name: "Hangman",						path: "/games/hangman", 	hard: false },
				{ name: "Sorry!",						path: "/games/sorry",		hard: false }
			]
		}
	],
	
	//Bottom describes the bottom of the navigation bar, and the items within the scroll area.
	bottom: [
		{ name: "About Us",			path: "/about",										hard: false										},
		{ name: "My Profile",		path: "/account",									hard: false										},
		{ name: "Settings",			path: "/account/settings",							hard: false										}
	],
	
	//Hard tells React to use <a> tags instead of <Link> to break out of React Router.
	//Use the hard setting in each item described above as needed. The one below
	//Is used for the account section dropdown, and for the logo home button.
	hard: false
};

export function Navbar() {
	return <>
		<NavbarTop />
		<NavbarBottom />
	</>;
}

export function NavbarBottom() {
	return layout.bottom instanceof Array ? <>
		<tr>
			<td>
				<Scroller />
			</td>
		</tr>
	</> : <></>;
}

export function NavbarTop() {
	//User information from UserContext.
	const _ = useContext(GlobalContext);
    window._ = _; //Debug.
	
	//State to store ID of active dropdown.
	const [ active, setActive ] = useState(-1);
	const activate = (id) => { setActive(active === id ? -1 : id); }

	//Get current route location.
	const location = useLocation();

	return layout.top instanceof Array ? <>
		<tr>
			<td>
				<table className="head">
					<tbody>
						<tr>
							<td>
								{/* Use logo to navigate back in browser history. Once at root, clicks will hard refresh page. Double clicks at any time will refresh to home page. */}
								<L className={"option icon left" + (location.pathname !== "/" ? " back" : "")} to={location.pathname !== "/" ? true : "/"} hard={location.pathname === "/"}>
									{location.pathname === "/" && <img src="/static/default/img/logo.png" alt="Husky Development Logo" onDoubleClick={() => { window.location.href = "/"; }} />}
								</L>
							</td>
							
							<td className="max">
								{layout.top.map((list, i) => { return <Dropdown active={active === i} id={i} key={i} setter={activate} />; })}
							</td>
							
							<td>
								<div className="dropdown right">
									<div className={"section icon small round frame" + (active === "profile" ? " active" : "")} onClick={() => { activate("profile"); }}>
										<span className="username">{_.user.name}</span>
										
										<span className="title">
											<img src={_.user.id > 0 ? "/static/default/img/userpic.png" : "/static/default/img/userpic.png"} alt="Profile" />
										</span>
										
										<div className="items">
											{ _.user.id > 0 ? <>
												<L to="/account" hard={layout.hard}>Profile</L>
												<L to="/account/logout" hard={layout.hard}>Logout</L>
											</> : <>
												<L to="/account/login" hard={layout.hard}>Login</L>
												<L to="/account/register" hard={layout.hard}>Sign Up</L>
											</>}
										</div>
									</div>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</td>
		</tr>
	</> : <></>;
}

function Dropdown({ active, id, setter, className }) {
	//User information from UserContext.
	const _ = useContext(GlobalContext);

	//Set data to the array of items to render.
	var [name, setName] = useState(layout.top[id].name);
	var [data, setData] = useState([]);

	className = "section" + (className ? " " + className : "") + (active ? " active" : "");

	useEffect(() => {
		//Filter out any items that does not meet their conditional requirements.
		setData(layout.top[id].items.filter(item => { if (item.conditional && !_.user?.permissions?.[item.conditional]) { return false; } return true; }));
    }, [_]);
	
	return data.length > 0 ? <div className="dropdown">
		<div className={className} onClick={() => { setter(id); }} id={"drop-section-" + id}>
			<span className="title">{name}</span>

			<div className="items">
				{data.map((item, i) => { return <L to={item.path} key={i} hard={item.hard}>{item.name}</L>; })}
			</div>
		</div>
	</div> : <></>;
}

function Scroller() {
	//User information from UserContext.
	const _ = useContext(GlobalContext);

	//Set data to the array of items to render.
	var [data, setData] = useState([]);

	useEffect(() => {
        //Filter out any items that does not meet their conditional requirements.
		setData(layout.bottom.filter(item => {
			if (item.conditional && !_.user?.permissions?.[item.conditional]) { return false; } return true;
		}));
	}, [_]);

	//Create a function for controlling left and right scrolling.
	const ScrollIt = (e, direction) => { e.target.parentElement.scrollLeft += (direction * 40); };
	
	return (
		<div className="navbar">
			<div className="container">
				<span className="scroll" onClick={e => ScrollIt(e, -1)}></span>
				{data.map((item, i) => { return <L key={i} className="item" to={item.path} hard={item.hard}>{item.name}</L> })}
				<span className="scroll" onClick={e => ScrollIt(e, 1)}></span>
			</div>
		</div>
	);
}

function L({ to, hard, children, className }) {
    //If to is true, this means go up one level in the path.
	if (to === true) { return <a className={className} onClick={() => window.history.back()}>{children}</a>; }

	//Otherwise, use to as the URL path.
	return hard ? <a href={to} className={className}>{children}</a> : <Link to={to} className={className}>{children}</Link>;
}